var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomDash = function SvgCustomDash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-80v-240h240v240zm280 0v-240h240v240zm280 0v-240h240v240zM80-360v-240h240v240zm280 0v-240h240v240zm280 0v-240h240v240zM80-640v-240h520v240zm560 0v-240h240v240zM440-240h80zM240-440v-80zm480 0v-80zM160-160h80v-80h-80zm280 0h80v-80h-80zm280 0h80v-80h-80zM160-440h80v-80h-80zm280 0h80v-80h-80zm280 0h80v-80h-80zm0-280h80v-80h-80z"
  })));
};
export default SvgCustomDash;